export const menuGroupingByServices = {
  en: [
    {
      title: 'Products',
      primaryKey: 'products',
      submenu: {
        categories: [
          {
            name: 'Selected products',
            primaryKey: 'featured-products',
            links: {
              size: 'wide',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Dedicated servers',
                  iconName: 'setup',
                  url: {
                    path: '/services/dedicated/',
                    hash: null
                  },
                  description: 'Segregated cloud-ready physical servers (any configuration)',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Cloud servers',
                  iconName: 'cloud-square',
                  url: {
                    path: '/services/cloud/servers/',
                    hash: null
                  },
                  description: 'Autoscaling virtual machine with Infrastructure-as-code support',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Public Cloud powered by&nbsp;VMware',
                  iconName: 'cloud-download',
                  url: {
                    path: '/services/cloud/vmware/public-cloud/',
                    hash: null
                  },
                  description: 'Cloud for any task from the leading VMware partner in&nbsp;Russia',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Kubernetes clusters',
                  iconName: 'kuber',
                  url: {
                    path: '/services/cloud/kubernetes/',
                    hash: null
                  },
                  description: 'Completely ready-to-use Kubernetes cluster for container management',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Cloud-Based Functions',
                  iconName: 'code',
                  url: {
                    path: '/services/cloud/serverless/',
                    hash: null
                  },
                  description: 'Request/event-triggered running of&nbsp;the code with no&nbsp;need to&nbsp;create and maintain a&nbsp;server',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Cloud databases',
                  iconName: 'radiator',
                  url: {
                    path: '/services/cloud/managed-databases/',
                    hash: null
                  },
                  description: 'Ready-to-use managed PostgreSQL and MySQL&trade; databases',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Object Storage',
                  iconName: 'settings',
                  url: {
                    path: '/services/cloud/storage/',
                    hash: null
                  },
                  description: 'Scalable data storage with flexible pricing, FTP and S3&nbsp;API support',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Hosting Equipment',
                  iconName: 'home',
                  url: {
                    path: '/services/colocation/server-colocation/',
                    hash: null
                  },
                  description: 'At&nbsp;TIER III data centers in&nbsp;Moscow, Saint Petersburg, and Leningrad Region',
                  additional: null
                }
              ]
            },
            widgets: {
              size: 'one-third',
              items: []
            }
          },
          {
            name: 'Dedicated servers',
            primaryKey: 'dedicated-servers',
            links: {
              size: 'wide',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Off-the-shelf Servers',
                  iconName: 'setup',
                  url: {
                    path: '/services/dedicated/',
                    hash: null
                  },
                  description: '70+&nbsp;ready-to-run configurations on&nbsp;up-to-date server hardware',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Server configurator',
                  iconName: 'settings',
                  url: {
                    path: '/services/dedicated/configurator/',
                    hash: null
                  },
                  description: 'Assembling a&nbsp;custom-built server from 5,000+ components',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Servers with consumer-grade CPUs',
                  iconName: 'settings-round',
                  url: {
                    path: '/services/dedicated/chipcore/',
                    hash: null
                  },
                  description: `Servers on&nbsp;desktop components with Intel&reg; Celeron, Intel&reg; Core и&nbsp;AMD Ryzen&trade; processors`,
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'GPU Servers',
                  iconName: 'processor',
                  url: {
                    path: '/services/dedicated/gpu/',
                    hash: null
                  },
                  description: 'High-performance dedicated servers with graphics accelerators',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Federal Law No. 152-FZ compliant servers',
                  iconName: 'shield',
                  url: {
                    path: '/services/is/dswes/',
                    hash: null
                  },
                  description: 'Server at&nbsp;a&nbsp;data center segment certified to&nbsp;process data up&nbsp;to&nbsp;UZ-1 (significance level)',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Server sale',
                  iconName: 'percent',
                  url: {
                    path: '/services/dedicated/sale/',
                    hash: null
                  },
                  description: 'Dedicated servers on&nbsp;previous-generation hardware are cheaper',
                  additional: null
                }
              ]
            },
            widgets: {
              size: 'one-third',
              items: []
            }
          },
          {
            name: 'Cloud Platform',
            primaryKey: 'cloud-platform',
            links: {
              size: 'wide',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Cloud servers',
                  iconName: 'cloud-square',
                  url: {
                    path: '/services/cloud/servers/',
                    hash: null
                  },
                  description: 'Autoscaling and No. 152-FZ-compliant virtual machines',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'GPU Cloud-Based Servers',
                  iconName: 'processor',
                  url: {
                    path: '/services/cloud/servers/gpu/',
                    hash: null
                  },
                  description: 'High-performance virtual machines with graphics accelerators',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Kubernetes clusters',
                  iconName: 'kuber',
                  url: {
                    path: '/services/cloud/kubernetes/',
                    hash: null
                  },
                  description: 'Completely ready-to-use Kubernetes cluster for container management',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Cloud-Based Functions',
                  iconName: 'code',
                  url: {
                    path: '/services/cloud/serverless/',
                    hash: null
                  },
                  description: 'Request/event-triggered running of&nbsp;the code with no&nbsp;need to&nbsp;create and maintain a&nbsp;server',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Cloud databases',
                  iconName: 'radiator',
                  url: {
                    path: '/services/cloud/managed-databases/',
                    hash: null
                  },
                  description: 'Ready-to-use managed PostgreSQL and MySQL&trade; databases',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Object Storage',
                  iconName: 'settings',
                  url: {
                    path: '/services/cloud/storage/',
                    hash: null
                  },
                  description: 'Scalable data storage with flexible pricing, FTP and S3&nbsp;API support',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Virtual Private Cloud',
                  iconName: 'lock',
                  url: {
                    path: '/services/cloud/vpc/',
                    hash: null
                  },
                  description: 'Segregated virtual infrastructure',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Cloud Load Balancer',
                  iconName: 'dots-path',
                  url: {
                    path: '/services/cloud/load-balancer/',
                    hash: null
                  },
                  description: 'Distribution of&nbsp;workloads across cloud servers to&nbsp;improve fault tolerance of&nbsp;your services and applications',
                  additional: null
                },
                {
                  externalTypeOfLink: true,
                  title: 'Data Science Virtual Machine',
                  iconName: 'chart-pie',
                  url: {
                    path: 'https://promo.selectel.ru/en/dsvm/',
                    hash: null
                  },
                  description: 'Virtual machines with pre-installed tools for&nbsp;AI developers and data analysts',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Resource calculator',
                  iconName: 'calculate',
                  url: {
                    path: '/services/cloud/servers/prices/',
                    hash: null
                  },
                  description: 'Estimate the cost of your future cloud',
                  additional: null
                }
              ]
            },
            widgets: {
              size: 'one-third',
              items: []
            }
          },
          {
            name: 'Cloud powered by VMware',
            primaryKey: 'cloud-powered-by-VMware',
            links: {
              size: 'wide',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Public VMware cloud',
                  iconName: 'cloud-square',
                  url: {
                    path: '/services/cloud/vmware/public-cloud/',
                    hash: null
                  },
                  description: 'Cloud for any task from the leading VMware partner in&nbsp;Russia',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'VMware containers',
                  iconName: 'target',
                  url: {
                    path: '/services/cloud/vmware/kubernetes/',
                    hash: null
                  },
                  description: 'Quickly launch and manage your applications in&nbsp;VMware-based containers',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Private VMware cloud',
                  iconName: 'lock',
                  url: {
                    path: '/services/cloud/vmware/private-cloud/',
                    hash: null
                  },
                  description: 'Maximum performance and control for business-critical applications in&nbsp;a&nbsp;segregated environment',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Federal Law No. 152-FZ cloud for VMware',
                  iconName: 'shield',
                  url: {
                    path: '/services/cloud/vmware/152-fz/',
                    hash: null
                  },
                  description: 'Storage and processing of&nbsp;personal data in&nbsp;the VMware cloud',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'VMware backup',
                  iconName: 'window-new',
                  url: {
                    path: '/services/cloud/vmware/vmware-backups/',
                    hash: null
                  },
                  description: 'Fast copying, reliable storage, and guaranteed recovery of&nbsp;VM data',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Disaster-proof cloud',
                  iconName: 'dots-fork',
                  url: {
                    path: '/services/cloud/vmware/draas/',
                    hash: '#vmware-region-infrastructure-reservation'
                  },
                  description: 'Infrastructure redundancy between two Selectel data centers',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Disaster Recovery',
                  iconName: 'dots-path',
                  url: {
                    path: '/services/cloud/vmware/draas/',
                    hash: '#vmware-infrastructure-reservation'
                  },
                  description: 'Disaster recovery of&nbsp;the VMware infrastructure to&nbsp;the Selectel cloud',
                  additional: null
                },
                {
                  externalTypeOfLink: true,
                  title: 'Microsoft SQL&trade; databases',
                  iconName: 'radiator',
                  url: {
                    path: 'https://promo.selectel.ru/mssql/',
                    hash: null
                  },
                  description: 'Ready-to-use Microsoft SQL&trade; databases in&nbsp;the Selectel cloud',
                  additional: null
                }
              ]
            },
            widgets: {
              size: 'one-third',
              items: []
            }
          },
          {
            name: 'Hosting Equipment',
            primaryKey: 'equipment-placement',
            links: {
              size: 'two-thirds',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Server hosting',
                  iconName: 'home',
                  url: {
                    path: '/services/colocation/server-colocation/',
                    hash: null
                  },
                  description: 'Hosting hardware of&nbsp;any format at&nbsp;TIER III data centers in&nbsp;Moscow, Saint Petersburg, and Leningrad Region',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Server Rack Rental',
                  iconName: 'setup',
                  url: {
                    path: '/services/colocation/server-rack/',
                    hash: null
                  },
                  description: 'Rent a&nbsp;part of&nbsp;or&nbsp;several racks at&nbsp;Selectel data centers',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Space rental',
                  iconName: 'target',
                  url: {
                    path: '/services/colocation/rentsquare/',
                    hash: null
                  },
                  description: 'Self-contained area with video surveillance, alarm system, and physical isolation for equipment placement',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Remote Maintenance',
                  iconName: 'settings-round',
                  url: {
                    path: '/services/colocation/server-rack/remote-smart/',
                    hash: null
                  },
                  description: 'Repair, configuration, and routine maintenance of&nbsp;the hosted hardware ',
                  additional: null
                }
              ]
            },
            widgets: {
              size: 'one-third',
              items: []
            }
          },
          {
            name: 'Network Services',
            primaryKey: 'network-services',
            links: {
              size: 'wide',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'DDoS Attack Protection',
                  iconName: 'shield',
                  url: {
                    path: '/services/additional/ddos-protection/',
                    hash: null
                  },
                  description: 'Inbound traffic filtering complex at&nbsp;L2, L3&nbsp;and L7&nbsp;network protocol level',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Web application protection (WAF)',
                  iconName: 'lock',
                  url: {
                    path: '/services/is/waf/',
                    hash: null
                  },
                  description: 'Protect your application from SQL injection, XSS scripting, and other OWASP threats',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Firewalls',
                  iconName: 'arrow-line',
                  url: {
                    path: '/services/additional/firewall/',
                    hash: null
                  },
                  description: 'Protect your projects from cyberattacks and information leaks, with complete control over traffic and data security',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Direct Connect',
                  iconName: 'dots-path',
                  url: {
                    path: '/solutions/hybrid-cloud/',
                    hash: null
                  },
                  description: 'Direct connection to&nbsp;AWS, GCP, Azure clouds worldwide',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Media Platform',
                  iconName: 'video',
                  url: {
                    path: '/services/additional/cdn/streaming/',
                    hash: null
                  },
                  description: 'Live streaming worldwide without delay in&nbsp;4K, 3D&nbsp;and 360&deg;',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Content Delivery Network',
                  iconName: 'thermometer',
                  url: {
                    path: '/services/additional/cdn/',
                    hash: null
                  },
                  description: 'Boost loading speeds and distribute static content quickly from servers around the world',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'DNS Hosting',
                  iconName: 'planet',
                  url: {
                    path: '/services/additional/dns/',
                    hash: null
                  },
                  description: 'Free hosting of&nbsp;domains and writebacks on&nbsp;Selectel DNS servers',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Monitoring',
                  iconName: 'eye',
                  url: {
                    path: '/services/additional/monitoring/',
                    hash: null
                  },
                  description: 'Check the availability of&nbsp;your service from different parts of&nbsp;the world',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Fiber Optic Lines',
                  iconName: 'dots-path',
                  url: {
                    path: '/services/additional/rentvols/',
                    hash: null
                  },
                  description: 'Connecting to&nbsp;main traffic exchange points in&nbsp;Moscow and Saint Petersburg',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Private network',
                  iconName: 'dots-fork',
                  url: {
                    path: '/services/additional/local-network/',
                    hash: null
                  },
                  description: 'Connect servers in&nbsp;different regions and services via a&nbsp;routed private network',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Load Balancer',
                  iconName: 'chart-column',
                  url: {
                    path: '/lab/general-load-balancer/',
                    hash: null
                  },
                  description: 'Distribution of&nbsp;inbound traffic for a&nbsp;group of&nbsp;servers',
                  additional: null
                }
              ]
            },
            widgets: {
              size: 'one-third',
              items: []
            }
          },
          {
            name: 'Partner services',
            primaryKey: 'partner-services',
            links: {
              size: 'wide',
              items: [
                {
                  externalTypeOfLink: false,
                  title: '1С',
                  iconName: 'pen',
                  url: {
                    path: '/services/1c-leasing/',
                    hash: null
                  },
                  description: 'Professional 1C&nbsp;hosting with paid subscription and rental of&nbsp;PROF and CORP licenses',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Microsoft 365',
                  iconName: 'pc',
                  url: {
                    path: '/services/cloud-apps/office365/',
                    hash: null
                  },
                  description: 'The classic office suite for business&mdash;now in&nbsp;the cloud',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Google Workspace',
                  iconName: 'dots-disconnected',
                  url: {
                    path: '/services/cloud-apps/google-workspace/',
                    hash: null
                  },
                  description: 'A&nbsp;suite of&nbsp;online services for document management, collaboration with co-workers and data storage',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Cloud Connect Repository',
                  iconName: 'window-multi',
                  url: {
                    path: '/services/additional/veeam-cloud-connect/',
                    hash: null
                  },
                  description: 'Storing Veeam backups in&nbsp;a&nbsp;cloud-based Selectel repository with triple replication',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Backup by&nbsp;agents',
                  iconName: 'window-new',
                  url: {
                    path: '/services/additional/backup-as-a-service/agent/',
                    hash: null
                  },
                  description: 'Create backup copies of&nbsp;applications, databases, volumes, files, physical and virtual machines using Veeam',
                  additional: null
                }
              ]
            },
            widgets: {
              size: 'one-third',
              items: []
            }
          },
          {
            name: 'Selectel Lab',
            primaryKey: 'selectel-lab',
            links: {
              size: 'wide',
              items: [
                {
                  externalTypeOfLink: true,
                  title: 'Data Science Docker Container',
                  iconName: 'target',
                  url: {
                    path: 'https://promo.selectel.ru/dsdc/',
                    hash: null
                  },
                  description: 'Pre-configured Docker image for neural network training and experimenting with data',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Video analytics',
                  iconName: 'camera',
                  url: {
                    path: '/solutions/video-analytics/',
                    hash: null
                  },
                  description: 'Automate video surveillance with&nbsp;AI and store records in&nbsp;the Selectel cloud',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Selectel HyperServer',
                  iconName: 'dots-fork',
                  url: {
                    path: '/solutions/hyperserver/',
                    hash: null
                  },
                  description: 'Server with tens of&nbsp;terabytes of&nbsp;RAM and hundreds of&nbsp;cores for in-memory computing',
                  additional: null
                }
              ]
            },
            widgets: {
              size: 'one-third',
              items: []
            }
          }
        ]
      }
    },
    {
      title: 'Solutions',
      primaryKey: 'solutions',
      submenu: {
        categories: [
          {
            name: 'For business tasks',
            primaryKey: 'by-business-objectives',
            links: {
              size: 'wide',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Cloud Migration',
                  iconName: 'cloud-upload',
                  url: {
                    path: '/solutions/cloud-migration/',
                    hash: null
                  },
                  description: 'Migrating your apps and services to&nbsp;the cloud with minimal risk and in&nbsp;a&nbsp;predictable timeframe',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Migrating to&nbsp;Selectel',
                  iconName: 'home',
                  url: {
                    path: '/onboarding/',
                    hash: null
                  },
                  description: 'Free migration of&nbsp;your projects and systems to&nbsp;the Selectel infrastructure',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'IT&nbsp;Cost Optimization',
                  iconName: 'calculate',
                  url: {
                    path: '/solutions/it-cost-optimization/',
                    hash: null
                  },
                  description: 'Audit and optimization of&nbsp;infrastructure to&nbsp;reduce&nbsp;IT infrastructure costs',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Law No. 152-FZ compliance',
                  iconName: 'shield',
                  url: {
                    path: '/solutions/pdps/',
                    hash: null
                  },
                  description: 'Choosing the&nbsp;IT infrastructure to&nbsp;comply with the law On&nbsp;Personal Data',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Fault-tolerant IT&nbsp;Infrastructure',
                  iconName: 'dots-fork',
                  url: {
                    path: '/solutions/resilient-infrastructure/',
                    hash: null
                  },
                  description: 'Advanced set of&nbsp;services for continuous business availability',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Information Security',
                  iconName: 'lock',
                  url: {
                    path: '/services/is/',
                    hash: null
                  },
                  description: 'Organizing protection against network attacks and unauthorized access',
                  additional: null
                }
              ]
            },
            widgets: {
              size: 'one-third',
              items: []
            }
          },
          {
            name: 'Tailored solutions',
            primaryKey: 'customized-solutions',
            links: {
              size: 'wide',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Multi-cloud environment',
                  iconName: 'cloud-square',
                  url: {
                    path: '/solutions/multi-cloud/',
                    hash: null
                  },
                  description: 'Combining Selectel services with AWS, Azure, GCP, and Alibaba cloud',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Hybrid Cloud',
                  iconName: 'cloud-square-1',
                  url: {
                    path: '/solutions/hybrid-cloud/',
                    hash: null
                  },
                  description: 'Combining on-premises infrastructure with Selectel cloud products or&nbsp;partner clouds',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Infrastructure for a&nbsp;CDN/PoP node',
                  iconName: 'planet',
                  url: {
                    path: '/solutions/cdn-infrastructure/',
                    hash: null
                  },
                  description: 'Arranging a&nbsp;communication hub in&nbsp;Moscow or&nbsp;Saint Petersburg with a&nbsp;direct connection to&nbsp;traffic exchange points',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Secure enclaves',
                  iconName: 'lock',
                  url: {
                    path: '/lab/anklav/',
                    hash: null
                  },
                  description: 'The Intel&reg; SGX technology and SCONE confidential computing',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Turnkey Data Center',
                  iconName: 'home',
                  url: {
                    path: '/solutions/data-center/',
                    hash: null
                  },
                  description: 'Deploying your data center on&nbsp;a&nbsp;ready-made Tier III infrastructure',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Custom Servers',
                  iconName: 'setup',
                  url: {
                    path: '/services/dedicated/preorder/',
                    hash: null
                  },
                  description: 'Finding, purchasing, delivery, and assembly of&nbsp;a&nbsp;custom-built server',
                  additional: null
                },
                {
                  externalTypeOfLink: true,
                  title: 'Server for SAP&reg; HANA',
                  iconName: 'chart-column',
                  url: {
                    path: 'https://promo.selectel.ru/hyperserver-sap-hana/',
                    hash: null
                  },
                  description: 'Scalable server for SAP&reg; HANA at&nbsp;a&nbsp;fraction of&nbsp;the price of&nbsp;similar solutions',
                  additional: null
                }
              ]
            },
            widgets: {
              size: 'one-third',
              items: []
            }
          }
        ]
      }
    },
    {
      title: 'Documentation',
      primaryKey: 'documentation',
      submenu: {
        categories: [
          {
            name: 'DOCUMENTATION',
            primaryKey: 'documentation',
            links: {
              size: 'wide',
              items: [
                {
                  externalTypeOfLink: true,
                  title: 'Knowledge base',
                  iconName: 'book',
                  url: {
                    path: 'https://kb.selectel.com/',
                    hash: null
                  },
                  description: 'All you need to&nbsp;know about Selectel products and how to&nbsp;work with them',
                  additional: {
                    links: [
                      {
                        externalTypeOfLink: true,
                        name: 'Working with S3&nbsp;Cloud Storage API',
                        url: {
                          path: 'https://kb.selectel.com/docs/cloud-services/cloud-storage/s3-api/storage_s3_api/',
                          hash: null
                        }
                      },
                      {
                        externalTypeOfLink: true,
                        name: 'Cloud server configurations',
                        url: {
                          path: 'https://kb.selectel.com/docs/selectel-cloud-platform/main-services/cloud-servers/cloud_servers/',
                          hash: null
                        }
                      },
                      {
                        externalTypeOfLink: true,
                        name: 'How to&nbsp;create a&nbsp;cloud-powered Telegram bot',
                        url: {
                          path: 'https://kb.selectel.com/docs/selectel-cloud-platform/serverless/instructions/how_to_create_a_telegram_bot/',
                          hash: null
                        }
                      },
                      {
                        externalTypeOfLink: true,
                        name: 'Connecting to&nbsp;a&nbsp;dedicated server via SSH/RDP',
                        url: {
                          path: 'https://kb.selectel.com/docs/servers-and-infrastructure/dedicated-servers/getting-started/connection_via_ssh_rdp/',
                          hash: null
                        }
                      },
                      {
                        externalTypeOfLink: true,
                        name: 'Connecting to&nbsp;a&nbsp;database in&nbsp;the PostgreSQL cluster',
                        url: {
                          path: 'https://kb.selectel.com/docs/selectel-cloud-platform/managed-databases/postgresql/connect_to_postgresql/',
                          hash: null
                        }
                      }
                    ]
                  }
                },
                {
                  externalTypeOfLink: true,
                  title: 'API documentation',
                  iconName: 'folder',
                  url: {
                    path: 'https://developers.selectel.com/',
                    hash: null
                  },
                  description: 'Tools for automating work with&nbsp;IT infrastructure',
                  additional: {
                    links: [
                      {
                        externalTypeOfLink: true,
                        name: 'Dedicated server API',
                        url: {
                          path: 'https://developers.selectel.com/docs/servers/dedicated_servers/',
                          hash: null
                        }
                      },
                      {
                        externalTypeOfLink: true,
                        name: 'Cloud function API',
                        url: {
                          path: 'https://developers.selectel.com/docs/selectel-cloud-platform/serverless_api/',
                          hash: null
                        }
                      },
                      {
                        externalTypeOfLink: true,
                        name: 'Status panel API',
                        url: {
                          path: 'https://developers.selectel.com/docs/control-panel/status_panel_api/',
                          hash: null
                        }
                      },
                      {
                        externalTypeOfLink: true,
                        name: 'DNS hosting API',
                        url: {
                          path: 'https://developers.selectel.com/docs/cloud-services/dns_api/',
                          hash: null
                        }
                      }
                    ]
                  }
                }
              ]
            },
            widgets: {
              size: 'two-thirds',
              items: []
            }
          }
        ]
      }
    },
    {
      title: 'Community',
      primaryKey: 'community',
      submenu: {
        categories: [
          {
            name: 'COMMUNITY',
            primaryKey: 'community',
            links: {
              size: 'one-third',
              items: [
                {
                  externalTypeOfLink: true,
                  title: 'Github',
                  iconName: 'code',
                  url: {
                    path: 'https://github.com/selectel',
                    hash: null
                  },
                  description: 'Tools for automating work with Selectel products',
                  additional: null
                },
                {
                  externalTypeOfLink: true,
                  title: 'Selectel Community',
                  iconName: 'people',
                  url: {
                    path: 'https://t.me/SelectelCommunity',
                    hash: null
                  },
                  description: 'Informal chat with our employees',
                  additional: null
                },
                {
                  externalTypeOfLink: true,
                  isVisibleOnMobile: true,
                  title: 'Blog',
                  iconName: 'doc',
                  url: {
                    path: 'https://blog.selectel.com/',
                    hash: null
                  },
                  description: 'About Selectel products, IT&nbsp;technologies and company life',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  isVisibleOnMobile: true,
                  title: 'Success stories',
                  iconName: 'star',
                  url: {
                    path: '/success-story/',
                    hash: null
                  },
                  description: 'How our products help customers to&nbsp;solve their problems',
                  additional: null
                }
              ]
            },
            widgets: {
              size: 'two-thirds',
              items: [
                {
                  externalTypeOfLink: true,
                  title: 'Blog',
                  url: {
                    path: 'https://blog.selectel.com/',
                    hash: null
                  },
                  componentName: 'BlogWidget',
                  primaryKey: 'blog'
                },
                {
                  externalTypeOfLink: false,
                  title: 'Success stories',
                  url: {
                    path: '/success-story/',
                    hash: null
                  },
                  componentName: 'SuccessStoryWidget',
                  primaryKey: 'successStory'
                }
              ]
            }
          }
        ]
      }
    },
    {
      title: 'Selectel',
      primaryKey: 'selectel',
      submenu: {
        categories: [
          {
            name: 'About the Company',
            primaryKey: 'about',
            links: {
              size: 'two-thirds',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'History of&nbsp;the Company',
                  iconName: 'selectel',
                  url: {
                    path: '/about/company/',
                    hash: null
                  },
                  description: '12&nbsp;years of&nbsp;creating the best cloud services in&nbsp;Russia &mdash;over 18,000 customers',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Data Centers',
                  iconName: 'home',
                  url: {
                    path: '/about/data-centers/',
                    hash: null
                  },
                  description: 'In&nbsp;Moscow, Saint Petersburg, and Leningrad Region',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Referral program',
                  iconName: 'people',
                  url: {
                    path: '/about/partners/referral-unlimited/',
                    hash: null
                  },
                  description: 'We&nbsp;pay&nbsp;9% of&nbsp;the price of&nbsp;services rendered to&nbsp;the referred customer',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Technical support',
                  iconName: 'phone',
                  url: {
                    path: '/support/',
                    hash: null
                  },
                  description: 'We&nbsp;are always here to&nbsp;consult, help, and troubleshoot',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  isVisibleOnMobile: true,
                  title: 'Contact information',
                  iconName: '',
                  url: {
                    path: '/about/contacts/',
                    hash: null
                  },
                  description: 'We&nbsp;are located in&nbsp;Russia, and work all over the world',
                  additional: null
                }
              ]
            },
            widgets: {
              size: 'one-third',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Contact information',
                  url: {
                    path: '/about/contacts/',
                    hash: null
                  },
                  componentName: 'contacts',
                  primaryKey: 'contacts'
                }
              ]
            }
          },
          {
            name: 'Career',
            primaryKey: 'career',
            links: {
              size: 'one-third',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Work at&nbsp;Selectel',
                  iconName: 'bag',
                  url: {
                    path: '/careers/',
                    hash: null
                  },
                  description: 'Join our team&mdash;it&rsquo;s great to&nbsp;be&nbsp;with&nbsp;us!',
                  additional: {
                    list: {
                      isNumbered: false,
                      items: [
                        'A&nbsp;large stable company with a&nbsp;startup atmosphere',
                        'You can contribute to&nbsp;processes and decision-making',
                        'You can create large-scale IT&nbsp;products',
                        'People are our top-priority&mdash;we develop, motivate, mentor, care'
                      ]
                    },
                    button: {
                      name: 'Send your CV',
                      url: {
                        path: '/careers/all/',
                        hash: '#form'
                      }
                    }
                  }
                },
                {
                  externalTypeOfLink: false,
                  isVisibleOnMobile: true,
                  title: 'Jobs',
                  iconName: 'people',
                  url: {
                    path: '/careers/all/',
                    hash: null
                  },
                  description: 'We&nbsp;are looking for talented, progressive and ambitious people',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  isVisibleOnMobile: true,
                  title: 'Internships',
                  iconName: 'people',
                  url: {
                    path: '/careers/internships/',
                    hash: null
                  },
                  description: 'Start of&nbsp;your career in&nbsp;IT',
                  additional: null
                }
              ]
            },
            widgets: {
              size: 'two-thirds',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Jobs',
                  url: {
                    path: '/careers/all/',
                    hash: null
                  },
                  componentName: 'Vacancies',
                  primaryKey: 'vacancies'
                },
                {
                  externalTypeOfLink: false,
                  title: 'Internships',
                  url: {
                    path: '/careers/internships/',
                    hash: null
                  },
                  componentName: 'Vacancies',
                  primaryKey: 'probation'
                }
              ]
            }
          },
          {
            name: 'For investors',
            primaryKey: 'investors',
            links: {
              size: 'one-third',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Invest in&nbsp;Selectel ',
                  iconName: 'doc',
                  url: {
                    path: '/investors/',
                    hash: null
                  },
                  description: 'Selectel is&nbsp;a&nbsp;fast-growing IT&nbsp;infrastructure provider with a&nbsp;12-year history, 18,000&nbsp;customers, and a&nbsp;team of&nbsp;500&nbsp;experts. We&nbsp;build the best cloud services powered by&nbsp;our 6&nbsp;data centers in&nbsp;Moscow, Saint Petersburg and the Leningrad Region',
                  additional: {
                    links: [
                      {
                        externalTypeOfLink: false,
                        name: 'Financial results',
                        url: {
                          path: '/investors/',
                          hash: '#financial-results'
                        }
                      },
                      {
                        externalTypeOfLink: false,
                        name: 'Information disclosure',
                        url: {
                          path: '/investors/',
                          hash: '#information-disclosure'
                        }
                      }
                    ]
                  }
                }
              ]
            },
            widgets: {
              size: 'two-thirds',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Credit ratings',
                  url: {
                    path: '/investors/',
                    hash: '#credit-ratings'
                  },
                  componentName: 'InvestorsWidget',
                  primaryKey: 'investors'
                }
              ]
            }
          },
          {
            name: 'Legal',
            primaryKey: 'lawyers',
            links: {
              size: 'wide',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Documents',
                  iconName: 'doc',
                  url: {
                    path: '/about/documents/',
                    hash: null
                  },
                  description: 'Contracts, agreements, deeds, policies, and other important documents',
                  additional: {
                    documents: [
                      {
                        externalTypeOfLink: true,
                        name: 'Terms of Service',
                        url: {
                          path: 'https://files.selectel.ru/docs/en/user-agreement.pdf',
                          hash: null
                        }
                      },
                      {
                        externalTypeOfLink: true,
                        name: 'Rules for using our services',
                        url: {
                          path: 'https://files.selectel.ru/docs/en/guidelines.pdf',
                          hash: null
                        }
                      }
                    ]
                  }
                },
                {
                  externalTypeOfLink: false,
                  title: 'Bank details and licenses',
                  iconName: 'text',
                  url: {
                    path: '/about/details/',
                    hash: null
                  },
                  description: 'Payment details, service rendering paperwork and mail delivery addresses',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Legal address',
                  iconName: 'marker',
                  url: {
                    path: '/about/contacts/',
                    hash: null
                  },
                  description: '21&nbsp;Tsvetochnaya&nbsp;St., letter A, <br> St. Petersburg 196084',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Archive',
                  iconName: 'folder',
                  url: {
                    path: '/about/documents/archive/',
                    hash: null
                  },
                  description: 'Previous versions of&nbsp;important documents',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Privacy Policy',
                  iconName: 'shield',
                  url: {
                    path: '/about/documents/personal-data/',
                    hash: null
                  },
                  description: 'We&nbsp;treat your personal data with caution',
                  additional: null
                },
                {
                  externalTypeOfLink: true,
                  title: 'Tenders and procurement',
                  iconName: 'pen',
                  url: {
                    path: 'https://old.selectel.ru/tenders/',
                    hash: null
                  },
                  description: 'Participation in&nbsp;Selectel&rsquo;s purchasing procedures',
                  additional: null
                }
              ]
            },
            widgets: {
              size: '',
              items: []
            }
          },
          {
            name: 'For mass media',
            primaryKey: 'press',
            links: {
              size: 'one-third',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'News and press releases',
                  iconName: 'chat',
                  url: {
                    path: '/about/newsroom/news/',
                    hash: null
                  },
                  description: 'We&nbsp;keep you informed of&nbsp;important company events',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Our press coverage',
                  iconName: 'doc',
                  url: {
                    path: '/about/newsroom/press/',
                    hash: null
                  },
                  description: 'Articles about Selectel in&nbsp;mass media',
                  additional: null
                },
                {
                  externalTypeOfLink: true,
                  title: 'pr@selectel.ru',
                  iconName: 'mail',
                  url: {
                    path: 'mailto:pr@selectel.ru',
                    hash: null
                  },
                  description: 'Take a&nbsp;comment, write an&nbsp;article, or&nbsp;invite to&nbsp;an&nbsp;event',
                  additional: null
                }
              ]
            },
            widgets: {
              size: 'two-thirds',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Selectel logo',
                  url: {
                    path: '/about/newsroom/materials/',
                    hash: '#company-logo'
                  },
                  componentName: 'MaterialsWidget',
                  primaryKey: 'selectel-logotypes'
                },
                {
                  externalTypeOfLink: false,
                  title: 'Selectel partners\' logo',
                  url: {
                    path: '/about/newsroom/materials/',
                    hash: '#company-partners-logos'
                  },
                  componentName: 'MaterialsWidget',
                  primaryKey: 'partners-logotypes'
                }
              ]
            }
          }
        ]
      }
    }
  ],
  ru: [
    {
      title: 'Продукты',
      primaryKey: 'products',
      submenu: {
        categories: [
          {
            name: 'Избранные продукты',
            primaryKey: 'featured-products',
            links: {
              size: 'wide',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Выделенные серверы',
                  iconName: 'setup',
                  url: {
                    path: '/services/dedicated/',
                    hash: null
                  },
                  description: 'Полностью изолированные физические серверы любой конфигурации с&nbsp;облачной готовностью',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Облачные серверы',
                  iconName: 'cloud-square',
                  url: {
                    path: '/services/cloud/servers/',
                    hash: null
                  },
                  description: 'Виртуальные машины с моментальным масштабированием и поддержкой Infrastructure-as-code',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Публичное облако на базе VMware',
                  iconName: 'cloud-download',
                  url: {
                    path: '/services/cloud/vmware/public-cloud/',
                    hash: null
                  },
                  description: 'Облако для любых задач от ведущего партнера VMware в России',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Кластеры Kubernetes',
                  iconName: 'kuber',
                  url: {
                    path: '/services/cloud/kubernetes/',
                    hash: null
                  },
                  description: 'Полностью готовый к работе кластер Kubernetes для управления контейнерами',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Облачные функции',
                  iconName: 'code',
                  url: {
                    path: '/services/cloud/serverless/',
                    hash: null
                  },
                  description: 'Запуск кода по запросу или событию без создания и обслуживания сервера',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Облачные базы данных',
                  iconName: 'radiator',
                  url: {
                    path: '/services/cloud/managed-databases/',
                    hash: null
                  },
                  description: 'Готовые к работе управляемые базы данных PostgreSQL и MySQL™',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Объектное хранилище',
                  iconName: 'settings',
                  url: {
                    path: '/services/cloud/storage/',
                    hash: null
                  },
                  description: 'Масштабируемое хранилище данных с&nbsp;гибким ценообразованием, поддержкой FTP и&nbsp;S3&nbsp;API',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Размещение оборудования',
                  iconName: 'home',
                  url: {
                    path: '/services/colocation/server-colocation/',
                    hash: null
                  },
                  description: 'В дата-центрах TIER III Москвы, Санкт&#8209;Петербурга и ЛО',
                  additional: null
                }
              ]
            },
            widgets: {
              size: 'one-third',
              items: []
            }
          },
          {
            name: 'Выделенные серверы',
            primaryKey: 'dedicated-servers',
            links: {
              size: 'wide',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Готовые серверы',
                  iconName: 'setup',
                  url: {
                    path: '/services/dedicated/',
                    hash: null
                  },
                  description: '70+&nbsp;готовых к&nbsp;работе конфигураций на&nbsp;актуальном серверном железе',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Конфигуратор серверов',
                  iconName: 'settings',
                  url: {
                    path: '/services/dedicated/configurator/',
                    hash: null
                  },
                  description: 'Сборка сервера под специальный запрос из 5000+ комплектующих',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Серверы с&nbsp;десктопными процессорами',
                  iconName: 'settings-round',
                  url: {
                    path: '/services/dedicated/chipcore/',
                    hash: null
                  },
                  description: `Серверы с&nbsp;процессорами Intel&reg; Celeron, Intel&reg; Core и&nbsp;AMD Ryzen&trade;`,
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Серверы с GPU',
                  iconName: 'processor',
                  url: {
                    path: '/services/dedicated/gpu/',
                    hash: null
                  },
                  description: 'Высокопроизводительные выделенные серверы с графическими ускорителями',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Серверы с&nbsp;Mac mini&reg;',
                  iconName: 'radiator',
                  url: {
                    path: '/services/dedicated/mac/',
                    hash: null
                  },
                  description: 'Производительное железо для всех, кто работает с&nbsp;macOS&reg; и&nbsp;iOS',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Серверы для 152-ФЗ',
                  iconName: 'shield',
                  url: {
                    path: '/services/is/dswes/',
                    hash: null
                  },
                  description: 'Размещение сервера в&nbsp;аттестованном сегменте ЦОД для работы с&nbsp;данными до&nbsp;УЗ-1',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Распродажа серверов',
                  iconName: 'percent',
                  url: {
                    path: '/services/dedicated/sale/',
                    hash: null
                  },
                  description: 'Выделенные серверы на железе предыдущего поколения дешевле',
                  additional: null
                }
              ]
            },
            widgets: {
              size: 'one-third',
              items: []
            }
          },
          {
            name: 'Облачная платформа',
            primaryKey: 'cloud-platform',
            links: {
              size: 'wide',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Облачные серверы',
                  iconName: 'cloud-square',
                  url: {
                    path: '/services/cloud/servers/',
                    hash: null
                  },
                  description: 'Виртуальные машины с&nbsp;моментальным масштабированием и&nbsp;соответствием 152&#8209;ФЗ',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Облачные серверы с GPU',
                  iconName: 'processor',
                  url: {
                    path: '/services/cloud/servers/gpu/',
                    hash: null
                  },
                  description: 'Высокопроизводительные виртуальные машины с графическими ускорителями',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Кластеры Kubernetes',
                  iconName: 'kuber',
                  url: {
                    path: '/services/cloud/kubernetes/',
                    hash: null
                  },
                  description: 'Полностью готовый к работе кластер Kubernetes для управления контейнерами',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Облачные функции',
                  iconName: 'code',
                  url: {
                    path: '/services/cloud/serverless/',
                    hash: null
                  },
                  description: 'Запуск кода по запросу или событию без создания и обслуживания сервера',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Облачные базы данных',
                  iconName: 'radiator',
                  url: {
                    path: '/services/cloud/managed-databases/',
                    hash: null
                  },
                  description: 'Готовые к работе управляемые базы данных PostgreSQL и MySQL™',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Объектное хранилище',
                  iconName: 'settings',
                  url: {
                    path: '/services/cloud/storage/',
                    hash: null
                  },
                  description: 'Масштабируемое хранилище данных с&nbsp;гибким ценообразованием, поддержкой FTP и&nbsp;S3&nbsp;API',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Виртуальное приватное облако',
                  iconName: 'lock',
                  url: {
                    path: '/services/cloud/vpc/',
                    hash: null
                  },
                  description: 'Полностью изолированная виртуальная инфраструктура',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Облачный балансировщик нагрузки',
                  iconName: 'dots-path',
                  url: {
                    path: '/services/cloud/load-balancer/',
                    hash: null
                  },
                  description: 'Распределение нагрузки между облачными серверами для повышения отказоустойчивости сервисов и&nbsp;приложений',
                  additional: null
                },
                {
                  externalTypeOfLink: true,
                  title: 'Data Science Virtual Machine',
                  iconName: 'chart-pie',
                  url: {
                    path: 'https://promo.selectel.ru/dsvm/',
                    hash: null
                  },
                  description: 'Виртуальные машины с&nbsp;готовыми к&nbsp;работе приложениями для разработчиков&nbsp;ИИ и&nbsp;аналитиков данных',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Калькулятор ресурсов',
                  iconName: 'calculate',
                  url: {
                    path: '/services/cloud/servers/prices/',
                    hash: null
                  },
                  description: 'Расчет стоимости вашего будущего облака',
                  additional: null
                }
              ]
            },
            widgets: {
              size: 'one-third',
              items: []
            }
          },
          {
            name: 'Облако на базе VMware',
            primaryKey: 'cloud-powered-by-VMware',
            links: {
              size: 'wide',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Публичное облако VMware',
                  iconName: 'cloud-square',
                  url: {
                    path: '/services/cloud/vmware/public-cloud/',
                    hash: null
                  },
                  description: 'Облако для любых задач от ведущего партнера VMware в России',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Контейнеры VMware',
                  iconName: 'target',
                  url: {
                    path: '/services/cloud/vmware/kubernetes/',
                    hash: null
                  },
                  description: 'Быстрый запуск и управление вашими приложениями в контейнерах на базе VMware',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Частное облако VMware',
                  iconName: 'lock',
                  url: {
                    path: '/services/cloud/vmware/private-cloud/',
                    hash: null
                  },
                  description: 'Максимальная производительность и&nbsp;контроль для бизнес-критичных приложений в&nbsp;изолированной среде',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Облако 152-ФЗ на базе VMware',
                  iconName: 'shield',
                  url: {
                    path: '/services/cloud/vmware/152-fz/',
                    hash: null
                  },
                  description: 'Хранение и обработка персональных данных в облаке на VMware',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Резервное копирование VMware',
                  iconName: 'window-new',
                  url: {
                    path: '/services/cloud/vmware/vmware-backups/',
                    hash: null
                  },
                  description: 'Быстрое копирование, надежное хранение и гарантированное восстановление данных ВМ',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Катастрофоустойчивое облако',
                  iconName: 'dots-fork',
                  url: {
                    path: '/services/cloud/vmware/draas/',
                    hash: '#vmware-region-infrastructure-reservation'
                  },
                  description: 'Резервирование инфраструктуры между двумя дата-центрами Selectel',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Disaster Recovery',
                  iconName: 'dots-path',
                  url: {
                    path: '/services/cloud/vmware/draas/',
                    hash: '#vmware-infrastructure-reservation'
                  },
                  description: 'Аварийное восстановление инфраструктуры VMware в облако Selectel',
                  additional: null
                },
                {
                  externalTypeOfLink: true,
                  title: 'Базы данных Microsoft SQL™',
                  iconName: 'radiator',
                  url: {
                    path: 'https://promo.selectel.ru/mssql/',
                    hash: null
                  },
                  description: 'Готовые к работе базы данных Microsoft SQL™ в облаке Selectel',
                  additional: null
                }
              ]
            },
            widgets: {
              size: 'one-third',
              items: []
            }
          },
          {
            name: 'Размещение оборудования',
            primaryKey: 'equipment-placement',
            links: {
              size: 'two-thirds',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Размещение серверов',
                  iconName: 'home',
                  url: {
                    path: '/services/colocation/server-colocation/',
                    hash: null
                  },
                  description: 'Размещение оборудования любого формата в дата-центрах TIER III Москвы, Санкт-Петербурга и ЛО',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Аренда стойки',
                  iconName: 'setup',
                  url: {
                    path: '/services/colocation/server-rack/',
                    hash: null
                  },
                  description: 'Аренда части или нескольких стоек в&nbsp;дата&#8209;центрах Selectel',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Аренда пространства',
                  iconName: 'target',
                  url: {
                    path: '/services/colocation/rentsquare/',
                    hash: null
                  },
                  description: 'Автономная зона с видеонаблюдением, сигнализацией и физической изоляцией для размещения оборудования',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Удаленное обслуживание',
                  iconName: 'settings-round',
                  url: {
                    path: '/services/colocation/server-rack/remote-smart/',
                    hash: null
                  },
                  description: 'Ремонт, настройка и плановое обслуживание размещаемого оборудования',
                  additional: null
                }
              ]
            },
            widgets: {
              size: 'one-third',
              items: []
            }
          },
          {
            name: 'Сетевые сервисы',
            primaryKey: 'network-services',
            links: {
              size: 'wide',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Защита от DDoS',
                  iconName: 'shield',
                  url: {
                    path: '/services/additional/ddos-protection/',
                    hash: null
                  },
                  description: 'Комплекс фильтрации входящего трафика на уровне сетевых протоколов L2, L3 и L7',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Защита приложения (WAF)',
                  iconName: 'lock',
                  url: {
                    path: '/services/is/waf/',
                    hash: null
                  },
                  description: 'Защита приложений от&nbsp;SQL&#8209;инъекций, скриптинга XSS и&nbsp;других угроз OWASP',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Межсетевые экраны',
                  iconName: 'arrow-line',
                  url: {
                    path: '/services/additional/firewall/',
                    hash: null
                  },
                  description: 'Защита проектов от кибератак и утечек информации, полный контроль над трафиком и сохранностью данных',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Балансировщик нагрузки',
                  iconName: 'chart-column',
                  url: {
                    path: '/lab/general-load-balancer/',
                    hash: null
                  },
                  description: 'Распределение входящего трафика для группы серверов',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Медиаплатформа',
                  iconName: 'video',
                  url: {
                    path: '/services/additional/cdn/streaming/',
                    hash: null
                  },
                  description: 'Онлайн-трансляции по&nbsp;всему миру без задержек в&nbsp;4K, 3D&nbsp;и&nbsp;360&deg;',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Сеть доставки контента',
                  iconName: 'thermometer',
                  url: {
                    path: '/services/additional/cdn/',
                    hash: null
                  },
                  description: 'Ускорение загрузки и&nbsp;быстрая раздача статического контента с&nbsp;серверов по&nbsp;всему миру',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'DNS-хостинг',
                  iconName: 'planet',
                  url: {
                    path: '/services/additional/dns/',
                    hash: null
                  },
                  description: 'Бесплатное размещение доменов и&nbsp;обратных записей на&nbsp;DNS-серверах Selectel',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Мониторинг',
                  iconName: 'eye',
                  url: {
                    path: '/services/additional/monitoring/',
                    hash: null
                  },
                  description: 'Проверка доступности вашего сервиса из&nbsp;разных точек мира',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Приватная сеть',
                  iconName: 'dots-fork',
                  url: {
                    path: '/services/additional/local-network/',
                    hash: null
                  },
                  description: 'Объединение серверов в разных регионах и сервисах через маршрутизируемую приватную сеть',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Волоконно-оптические линии связи',
                  iconName: 'dots-path',
                  url: {
                    path: '/services/additional/rentvols/',
                    hash: null
                  },
                  description: 'Подключение к основным точкам обмена трафиком в Москве и Санкт-Петербурге',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Direct Connect',
                  iconName: 'dots-path',
                  url: {
                    path: '/solutions/hybrid-cloud/',
                    hash: null
                  },
                  description: 'Прямое подключение к облакам AWS, GCP, Azure по всему миру',
                  additional: null
                }
              ]
            },
            widgets: {
              size: 'one-third',
              items: []
            }
          },
          {
            name: 'Сервисы партнеров',
            primaryKey: 'partner-services',
            links: {
              size: 'wide',
              items: [
                {
                  externalTypeOfLink: false,
                  title: '1С',
                  iconName: 'pen',
                  url: {
                    path: '/services/1c-leasing/',
                    hash: null
                  },
                  description: 'Профессиональный хостинг 1С с оплатой по подписке и арендой лицензий уровня ПРОФ и КОРП',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Microsoft 365',
                  iconName: 'pc',
                  url: {
                    path: '/services/cloud-apps/office365/',
                    hash: null
                  },
                  description: 'Традиционный офисный пакет для бизнеса — теперь в облаке',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Google Workspace',
                  iconName: 'dots-disconnected',
                  url: {
                    path: '/services/cloud-apps/google-workspace/',
                    hash: null
                  },
                  description: 'Набор онлайн-сервисов для работы с&nbsp;документами, взаимодействия с&nbsp;коллегами и&nbsp;хранения данных',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Облачный репозиторий Cloud Connect',
                  iconName: 'window-multi',
                  url: {
                    path: '/services/additional/veeam-cloud-connect/',
                    hash: null
                  },
                  description: 'Хранение резервных копий Veeam в&nbsp;облачном репозитории Selectel с&nbsp;тройной репликацией',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Резервное копирование агентами',
                  iconName: 'window-new',
                  url: {
                    path: '/services/additional/backup-as-a-service/agent/',
                    hash: null
                  },
                  description: 'Создание резервных копий приложений, баз данных, томов, файлов, физических и&nbsp;виртуальных машин с&nbsp;помощью Veeam',
                  additional: null
                }
              ]
            },
            widgets: {
              size: 'one-third',
              items: []
            }
          },
          {
            name: 'Selectel Lab',
            primaryKey: 'selectel-lab',
            links: {
              size: 'wide',
              items: [
                {
                  externalTypeOfLink: true,
                  title: 'Data Science Docker Container',
                  iconName: 'target',
                  url: {
                    path: 'https://promo.selectel.ru/dsdc/',
                    hash: null
                  },
                  description: 'Преднастроенный Docker-образ для обучения нейросетей и&nbsp;экспериментов с&nbsp;данными',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Видеоаналитика',
                  iconName: 'camera',
                  url: {
                    path: '/solutions/video-analytics/',
                    hash: null
                  },
                  description: 'Автоматизация видеонаблюдения с&nbsp;помощью&nbsp;ИИ и&nbsp;хранение записей в&nbsp;облаке Selectel',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Selectel HyperServer',
                  iconName: 'dots-fork',
                  url: {
                    path: '/solutions/hyperserver/',
                    hash: null
                  },
                  description: 'Сервер с десятками терабайт оперативной памяти и сотнями ядер для in-memory-вычислений',
                  additional: null
                }
              ]
            },
            widgets: {
              size: 'one-third',
              items: []
            }
          }
        ]
      }
    },
    {
      title: 'Решения',
      primaryKey: 'solutions',
      submenu: {
        categories: [
          {
            name: 'По бизнес-задачам',
            primaryKey: 'by-business-objectives',
            links: {
              size: 'wide',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Миграция в&nbsp;облако',
                  iconName: 'cloud-upload',
                  url: {
                    path: '/solutions/cloud-migration/',
                    hash: null
                  },
                  description: 'Перенос ваших приложений и&nbsp;сервисов в&nbsp;облако с&nbsp;минимальными рисками и&nbsp;в&nbsp;прогнозируемые сроки',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Переезд в&nbsp;Selectel',
                  iconName: 'home',
                  url: {
                    path: '/onboarding/',
                    hash: null
                  },
                  description: 'Бесплатный перенос ваших проектов и&nbsp;систем на&nbsp;инфраструктуру Selectel',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Администрирование сервисов',
                  iconName: 'eye',
                  url: {
                    path: '/solutions/managed-services/',
                    hash: null
                  },
                  description: 'Организация стабильной работы IT&#8209;систем силами наших администраторов',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Оптимизация IT-затрат',
                  iconName: 'calculate',
                  url: {
                    path: '/solutions/it-cost-optimization/',
                    hash: null
                  },
                  description: 'Аудит и&nbsp;оптимизация инфраструктуры для сокращения затрат на&nbsp;IT&#8209;инфраструктуру',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Соответствие 152-ФЗ',
                  iconName: 'shield',
                  url: {
                    path: '/solutions/pdps/',
                    hash: null
                  },
                  description: 'Выбор IT-инфраструктуры для соответствия закону «О персональных данных»',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Отказоустойчивая IT&#8209;инфраструктура',
                  iconName: 'dots-fork',
                  url: {
                    path: '/solutions/resilient-infrastructure/',
                    hash: null
                  },
                  description: 'Продвинутый комплекс сервисов для непрерывной доступности бизнеса',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Информационная безопасность',
                  iconName: 'lock',
                  url: {
                    path: '/services/is/',
                    hash: null
                  },
                  description: 'Организация защиты от&nbsp;сетевых атак и&nbsp;несанкционированного доступа',
                  additional: null
                }
              ]
            },
            widgets: {
              size: 'one-third',
              items: []
            }
          },
          {
            name: 'Индивидуальные решения',
            primaryKey: 'customized-solutions',
            links: {
              size: 'wide',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Мультиоблачная среда',
                  iconName: 'cloud-square',
                  url: {
                    path: '/solutions/multi-cloud/',
                    hash: null
                  },
                  description: 'Объединение сервисов Selectel с облаком AWS, Azure, GCP и Alibaba',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Гибридное облако',
                  iconName: 'cloud-square-1',
                  url: {
                    path: '/solutions/hybrid-cloud/',
                    hash: null
                  },
                  description: 'Объединение локальной инфраструктуры с облачными продуктами Selectel или облаками партнеров',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Инфраструктура для узла CDN/PoP',
                  iconName: 'planet',
                  url: {
                    path: '/solutions/cdn-infrastructure/',
                    hash: null
                  },
                  description: 'Организация узла связи в Москве или Петербурге с прямым подключением к точкам обмена трафиком',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Защищенные анклавы',
                  iconName: 'lock',
                  url: {
                    path: '/lab/anklav/',
                    hash: null
                  },
                  description: 'Конфиденциальные вычисления на базе технологии Intel® SGX и платформы SCONE',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Дата-центр под ключ',
                  iconName: 'home',
                  url: {
                    path: '/solutions/data-center/',
                    hash: null
                  },
                  description: 'Развертывание вашего дата-центра на готовой инфраструктуре Tier III',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Серверы под заказ',
                  iconName: 'setup',
                  url: {
                    path: '/services/dedicated/preorder/',
                    hash: null
                  },
                  description: 'Поиск, закупка, доставка и сборка сервера по индивидуальному запросу',
                  additional: null
                },
                {
                  externalTypeOfLink: true,
                  title: 'Сервер для SAP® HANA',
                  iconName: 'chart-column',
                  url: {
                    path: 'https://promo.selectel.ru/hyperserver-sap-hana/',
                    hash: null
                  },
                  description: 'Масштабируемый сервер для SAP® HANA по цене в несколько раз ниже аналогичных решений',
                  additional: null
                }
              ]
            },
            widgets: {
              size: 'one-third',
              items: []
            }
          }
        ]
      }
    },
    {
      title: 'Документация',
      primaryKey: 'documentation',
      submenu: {
        categories: [
          {
            name: 'Документация',
            primaryKey: 'documentation',
            links: {
              size: 'wide',
              items: [
                {
                  externalTypeOfLink: true,
                  title: 'База знаний',
                  iconName: 'book',
                  url: {
                    path: 'https://kb.selectel.ru/',
                    hash: null
                  },
                  description: 'Все о&nbsp;продуктах Selectel и&nbsp;как с&nbsp;ними работать',
                  additional: {
                    links: [
                      {
                        externalTypeOfLink: true,
                        name: 'Работа с&nbsp;S3&nbsp;API &laquo;Облачного хранилища&raquo;',
                        url: {
                          path: 'https://kb.selectel.ru/docs/cloud-services/cloud-storage/s3-api/storage_s3_api/',
                          hash: null
                        }
                      },
                      {
                        externalTypeOfLink: true,
                        name: 'Конфигурации облачных серверов',
                        url: {
                          path: 'https://kb.selectel.ru/docs/selectel-cloud-platform/main-services/cloud-servers/cloud_servers/',
                          hash: null
                        }
                      },
                      {
                        externalTypeOfLink: true,
                        name: 'Как создать телеграм&#8209;бота на&nbsp;облачных функциях',
                        url: {
                          path: 'https://kb.selectel.ru/docs/selectel-cloud-platform/serverless/instructions/how_to_create_a_telegram_bot/',
                          hash: null
                        }
                      },
                      {
                        externalTypeOfLink: true,
                        name: 'Подключение к выделенному серверу по SSH/RDP',
                        url: {
                          path: 'https://kb.selectel.ru/docs/servers-and-infrastructure/dedicated-servers/getting-started/connection_via_ssh_rdp/',
                          hash: null
                        }
                      },
                      {
                        externalTypeOfLink: true,
                        name: 'Подключение к базе данных в кластере PostgreSQL',
                        url: {
                          path: 'https://kb.selectel.ru/docs/selectel-cloud-platform/managed-databases/postgresql/connect_to_postgresql/',
                          hash: null
                        }
                      }
                    ]
                  }
                },
                {
                  externalTypeOfLink: true,
                  title: 'Документация к&nbsp;API',
                  iconName: 'folder',
                  url: {
                    path: 'https://developers.selectel.ru/',
                    hash: null
                  },
                  description: 'Инструменты для автоматизации работы с&nbsp;IT&#8209;инфраструктурой',
                  additional: {
                    links: [
                      {
                        externalTypeOfLink: true,
                        name: 'API выделенных серверов',
                        url: {
                          path: 'https://developers.selectel.ru/docs/servers/dedicated_servers/',
                          hash: null
                        }
                      },
                      {
                        externalTypeOfLink: true,
                        name: 'Авторизация',
                        url: {
                          path: 'https://developers.selectel.ru/docs/control-panel/authorization/',
                          hash: null
                        }
                      },
                      {
                        externalTypeOfLink: true,
                        name: 'API облачных функций',
                        url: {
                          path: 'https://developers.selectel.ru/docs/selectel-cloud-platform/serverless_api/',
                          hash: null
                        }
                      },
                      {
                        externalTypeOfLink: true,
                        name: 'API статус-панели',
                        url: {
                          path: 'https://developers.selectel.ru/docs/control-panel/status_panel_api/',
                          hash: null
                        }
                      },
                      {
                        externalTypeOfLink: true,
                        name: 'API DNS-хостинга',
                        url: {
                          path: 'https://developers.selectel.ru/docs/cloud-services/dns_api/',
                          hash: null
                        }
                      }
                    ]
                  }
                },
                {
                  externalTypeOfLink: false,
                  title: 'Полезные материалы',
                  iconName: 'star',
                  url: {
                    path: '/wp/',
                    hash: null
                  },
                  description: 'Развернутые ответы на&nbsp;популярные IT&#8209;вопросы в&nbsp;формате обзоров и&nbsp;книг',
                  additional: {
                    links: [
                      {
                        externalTypeOfLink: false,
                        name: 'Гибридное облако&nbsp;&mdash; советы по&nbsp;реализации гибридной IT&#8209;стратегии',
                        url: {
                          path: '/wp/hybrid-it-strategy-implementation/',
                          hash: null
                        }
                      },
                      {
                        externalTypeOfLink: false,
                        name: 'Создание геораспределенной инфраструктурной платформы для приложений на базе Selectel и AWS',
                        url: {
                          path: '/wp/geo-distributed-infrastructure/',
                          hash: null
                        }
                      },
                      {
                        externalTypeOfLink: false,
                        name: 'Доступность сервисов в&nbsp;облаках',
                        url: {
                          path: '/wp/cloud-service-availability/',
                          hash: null
                        }
                      },
                      {
                        externalTypeOfLink: false,
                        name: 'Администрирование сервисов',
                        url: {
                          path: '/wp/managed-checklist/',
                          hash: null
                        }
                      },
                      {
                        externalTypeOfLink: false,
                        name: 'Правила хорошего бэкапа',
                        url: {
                          path: '/wp/backup-checklist/',
                          hash: null
                        }
                      }
                    ]
                  }
                }
              ]
            },
            widgets: {
              size: 'two-thirds',
              items: []
            }
          }
        ]
      }
    },
    {
      title: 'Сообщество',
      primaryKey: 'community',
      submenu: {
        categories: [
          {
            name: 'Сообщество',
            primaryKey: 'community',
            links: {
              size: 'one-third',
              items: [
                {
                  externalTypeOfLink: true,
                  title: 'Github',
                  iconName: 'code',
                  url: {
                    path: 'https://github.com/selectel',
                    hash: null
                  },
                  description: 'Инструменты для автоматизации работы с&nbsp;продуктами Selectel',
                  additional: null
                },
                {
                  externalTypeOfLink: true,
                  title: 'Selectel Community',
                  iconName: 'people',
                  url: {
                    path: 'https://t.me/SelectelCommunity',
                    hash: null
                  },
                  description: 'Ламповый чат с&nbsp;сотрудниками компании',
                  additional: null
                },
                {
                  externalTypeOfLink: true,
                  isVisibleOnMobile: true,
                  title: 'Блог',
                  iconName: 'doc',
                  url: {
                    path: 'https://selectel.ru/blog',
                    hash: null
                  },
                  description: 'О&nbsp;продуктах Selectel, IT&#8209;технологиях и&nbsp;жизни компании',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  isVisibleOnMobile: true,
                  title: 'Истории успеха',
                  iconName: 'star',
                  url: {
                    path: '/success-story/',
                    hash: null
                  },
                  description: 'О&nbsp;том, как наши продукты помогают в&nbsp;решении клиентских задач\n',
                  additional: null
                }
              ]
            },
            widgets: {
              size: 'two-thirds',
              items: [
                {
                  externalTypeOfLink: true,
                  title: 'Блог',
                  url: {
                    path: 'https://selectel.ru/blog',
                    hash: null
                  },
                  componentName: 'BlogWidget',
                  primaryKey: 'blog'
                },
                {
                  externalTypeOfLink: false,
                  title: 'Истории успеха',
                  url: {
                    path: '/success-story/',
                    hash: null
                  },
                  componentName: 'SuccessStoryWidget',
                  primaryKey: 'successStory'
                }
              ]
            }
          }
        ]
      }
    },
    {
      title: 'Selectel',
      primaryKey: 'selectel',
      submenu: {
        categories: [
          {
            name: 'О компании',
            primaryKey: 'about',
            links: {
              size: 'two-thirds',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'История компании',
                  iconName: 'selectel',
                  url: {
                    path: '/about/company/',
                    hash: null
                  },
                  description: '12&nbsp;лет создаем лучшие облачные сервисы в&nbsp;России&nbsp;&mdash; 18&nbsp;000+ клиентов с&nbsp;нами',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Дата-центры',
                  iconName: 'home',
                  url: {
                    path: '/about/data-centers/',
                    hash: null
                  },
                  description: 'В&nbsp;Москве, Санкт&#8209;Петербурге и&nbsp;Ленинградской области',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Реферальная программа',
                  iconName: 'people',
                  url: {
                    path: '/about/partners/referral-unlimited/',
                    hash: null
                  },
                  description: 'Выплачиваем 9% от суммы оказанных услуг привлеченному клиенту',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Техническая поддержка',
                  iconName: 'phone',
                  url: {
                    path: '/support/',
                    hash: null
                  },
                  description: 'В&nbsp;любое время подскажем, поможем и&nbsp;устраним неполадки',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  isVisibleOnMobile: true,
                  title: 'Контакты',
                  iconName: '',
                  url: {
                    path: '/about/contacts/',
                    hash: null
                  },
                  description: 'Расположены в&nbsp;России, работаем по&nbsp;всему миру',
                  additional: null
                }
              ]
            },
            widgets: {
              size: 'one-third',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Контакты',
                  url: {
                    path: '/about/contacts/',
                    hash: null
                  },
                  componentName: 'contacts',
                  primaryKey: 'contacts'
                }
              ]
            }
          },
          {
            name: 'Карьера',
            primaryKey: 'career',
            links: {
              size: 'one-third',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Работа в&nbsp;Selectel',
                  iconName: 'bag',
                  url: {
                    path: '/careers/',
                    hash: null
                  },
                  description: 'Станьте частью нашей команды&nbsp;&mdash; у&nbsp;нас здорово!',
                  additional: {
                    list: {
                      isNumbered: false,
                      items: [
                        'Большая стабильная компания с&nbsp;атмосферой стартапа',
                        'Можно влиять на&nbsp;процессы и&nbsp;принятие решений',
                        'Возможность создавать масштабные IT&#8209;продукты',
                        'Люди важнее всего&nbsp;&mdash; развиваем, мотивируем, менторим, заботимся'
                      ]
                    },
                    button: {
                      name: 'Отправить резюме',
                      url: {
                        path: '/careers/all/',
                        hash: '#form'
                      }
                    }
                  }
                },
                {
                  externalTypeOfLink: false,
                  isVisibleOnMobile: true,
                  title: 'Вакансии',
                  iconName: 'people',
                  url: {
                    path: '/careers/all/',
                    hash: null
                  },
                  description: 'Ищем талантливых, прогрессивных и&nbsp;амбициозных',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  isVisibleOnMobile: true,
                  title: 'Стажировки',
                  iconName: 'people',
                  url: {
                    path: '/careers/internships/',
                    hash: null
                  },
                  description: 'Ваш старт карьеры в&nbsp;IT',
                  additional: null
                }
              ]
            },
            widgets: {
              size: 'two-thirds',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Вакансии',
                  url: {
                    path: '/careers/all/',
                    hash: null
                  },
                  componentName: 'Vacancies',
                  primaryKey: 'vacancies'
                },
                {
                  externalTypeOfLink: false,
                  title: 'Стажировки',
                  url: {
                    path: '/careers/internships/',
                    hash: null
                  },
                  componentName: 'Vacancies',
                  primaryKey: 'probation'
                }
              ]
            }
          },
          {
            name: 'Инвесторам',
            primaryKey: 'investors',
            links: {
              size: 'one-third',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Инвестиции в Selectel',
                  iconName: 'doc',
                  url: {
                    path: '/investors/',
                    hash: null
                  },
                  description: 'Selectel&nbsp;— быстрорастущий провайдер IT-инфраструктуры с&nbsp;12-летней историей, 18&nbsp;000&nbsp;клиентами и&nbsp;командой из&nbsp;500&nbsp;человек. Мы&nbsp;создаем лучшие облачные сервисы на&nbsp;базе 6&nbsp;своих дата-центров в&nbsp;Москве, Санкт-Петербурге и&nbsp;Ленинградской области',
                  additional: {
                    links: [
                      {
                        externalTypeOfLink: false,
                        name: 'Финансовые результаты',
                        url: {
                          path: '/investors/',
                          hash: '#financial-results'
                        }
                      },
                      {
                        externalTypeOfLink: false,
                        name: 'Раскрытие информации',
                        url: {
                          path: '/investors/',
                          hash: '#information-disclosure'
                        }
                      }
                    ]
                  }
                }
              ]
            },
            widgets: {
              size: 'two-thirds',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Кредитные рейтинги',
                  url: {
                    path: '/investors/',
                    hash: '#credit-ratings'
                  },
                  componentName: 'InvestorsWidget',
                  primaryKey: 'investors'
                }
              ]
            }
          },
          {
            name: 'Юристам',
            primaryKey: 'lawyers',
            links: {
              size: 'wide',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Документы',
                  iconName: 'doc',
                  url: {
                    path: '/about/documents/',
                    hash: null
                  },
                  description: 'Договоры, соглашения, акты, политики и&nbsp;другие важные бумаги',
                  additional: {
                    documents: [
                      {
                        externalTypeOfLink: true,
                        name: 'Пользовательское соглашение',
                        url: {
                          path: 'https://files.selectel.ru/docs/ru/user-agreement.pdf',
                          hash: null
                        }
                      },
                      {
                        externalTypeOfLink: true,
                        name: 'Правила пользования  сервисами и услугами',
                        url: {
                          path: 'https://files.selectel.ru/docs/ru/terms-of-use-for-services.pdf',
                          hash: null
                        }
                      }
                    ]
                  }
                },
                {
                  externalTypeOfLink: false,
                  title: 'Реквизиты и лицензии',
                  iconName: 'text',
                  url: {
                    path: '/about/details/',
                    hash: null
                  },
                  description: 'Платежная информация, документы на&nbsp;оказание услуг и&nbsp;адреса доставки почты',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Юридический адрес',
                  iconName: 'marker',
                  url: {
                    path: '/about/contacts/',
                    hash: null
                  },
                  description: '196084, г. Санкт-Петербург, <br> ул. Цветочная, д.&nbsp;21, лит. А',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Архив',
                  iconName: 'folder',
                  url: {
                    path: '/about/documents/archive/',
                    hash: null
                  },
                  description: 'Предыдущие версии важных документов',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Политика конфиденциальности',
                  iconName: 'shield',
                  url: {
                    path: '/about/documents/personal-data/',
                    hash: null
                  },
                  description: 'Бережно обращаемся с&nbsp;персональными данными',
                  additional: null
                },
                {
                  externalTypeOfLink: true,
                  title: 'Тендеры и закупки',
                  iconName: 'pen',
                  url: {
                    path: 'https://old.selectel.ru/tenders/',
                    hash: null
                  },
                  description: 'Участие в&nbsp;торговых процедурах Selectel',
                  additional: null
                }
              ]
            },
            widgets: {
              size: '',
              items: []
            }
          },
          {
            name: 'Прессе',
            primaryKey: 'press',
            links: {
              size: 'one-third',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Новости и пресс-релизы',
                  iconName: 'chat',
                  url: {
                    path: '/about/newsroom/news/',
                    hash: null
                  },
                  description: 'Держим в&nbsp;курсе важных событий компании',
                  additional: null
                },
                {
                  externalTypeOfLink: false,
                  title: 'Пресса о нас',
                  iconName: 'doc',
                  url: {
                    path: '/about/newsroom/press/',
                    hash: null
                  },
                  description: 'Что о&nbsp;Selectel пишут в&nbsp;СМИ',
                  additional: null
                },
                {
                  externalTypeOfLink: true,
                  title: 'pr@selectel.ru',
                  iconName: 'mail',
                  url: {
                    path: 'mailto:pr@selectel.ru',
                    hash: null
                  },
                  description: 'Взять комментарий, написать статью или пригласить на&nbsp;мероприятие',
                  additional: null
                }
              ]
            },
            widgets: {
              size: 'two-thirds',
              items: [
                {
                  externalTypeOfLink: false,
                  title: 'Логотип Selectel',
                  url: {
                    path: '/about/newsroom/materials/',
                    hash: '#company-logo'
                  },
                  componentName: 'MaterialsWidget',
                  primaryKey: 'selectel-logotypes'
                },
                {
                  externalTypeOfLink: false,
                  title: 'Логотип партнера Selectel',
                  url: {
                    path: '/about/newsroom/materials/',
                    hash: '#company-partners-logos'
                  },
                  componentName: 'MaterialsWidget',
                  primaryKey: 'partners-logotypes'
                }
              ]
            }
          }
        ]
      }
    }
  ]
}